import { ReactNode } from 'react';
import { FormLabel } from '@chakra-ui/react';

// Abstraction helper to avoid repeating style info on form labels

export const DonationFormLabel = ({
  children,
  htmlFor,
  ...rest
}: {
  children: ReactNode;
  htmlFor: string;
}) => (
  <FormLabel htmlFor={htmlFor} {...rest}>
    {children}
  </FormLabel>
);
